import { api } from './client';

export interface FaqEntry { id: string; question: string; answer: string; category: string | null; sortOrder: number; }
export interface LegalPage { id: string; slug: string; title: string; body: string; updatedAt: string; }
export interface SocialLink { id: string; platform: string; url: string; label?: string; }

export const fetchPublicFaq = () => api.get<FaqEntry[]>('/cms/faq').then(r => r.data);
export const fetchLegalPage = (slug: string) => api.get<LegalPage>(`/cms/legal/${slug}`).then(r => r.data);
export const fetchSocialLinks = () => api.get<SocialLink[]>('/cms/social-links').then(r => r.data);

/** An admin-enabled payment rail (`GET /cms/payment-methods`), already in display order. */
export interface PaymentMethod { slug: string; name: string; icon?: string; }
export const fetchPaymentMethods = () => api.get<PaymentMethod[]>('/cms/payment-methods').then(r => r.data);
